<template>
    <div class="edit-profile-detail">
        <div class="section">
            <div class="content f-15" style="line-height: 24px; margin: 24px 20px">
                Q. 굿퍼슨은 신원, 직장 정보 등을 서류로 인증하는 것은 신뢰도를 높이고, 진정성 있는 마음의 토대가 되는
                일이라고 생각합니다.<br />
                이에 동의하시나요?
            </div>
            <div class="column">
                <div
                    class="item bg-white m-l-20 m-r-20"
                    :class="{ selected: item.id === selectedIdx }"
                    v-for="item in items"
                    :key="item.id"
                    v-html="item.name"
                    @click="onClickItem(item.id)"
                />
            </div>
        </div>
        <!--        <BottomButton :disabled="disabled" @click="next" :label="$translate('NEXT')" />-->
    </div>
</template>

<script>
import signupConstant from '@/assets/constants/onboard-temp-signup'
export default {
    name: 'AgreeVerification',
    data: () => ({
        selectedIdx: null,
    }),
    computed: {
        tempSignupPayload() {
            return JSON.parse(localStorage.getItem('tempSignupPayload')) || {}
        },
        items() {
            return signupConstant.agreeVerification
        },
        disabled() {
            return this.selectedIdx === null
        },
    },
    methods: {
        onClickItem(idx) {
            if (idx === 2) {
                this.$modal.basic({
                    body: '커뮤니티 방향성에 동의하지 않는 분의 경우 가입이 어렵습니다. 죄송합니다.',
                    buttons: [
                        {
                            label: '확인',
                            class: 'btn-primary',
                        },
                    ],
                })
            } else {
                this.selectedIdx = idx

                setTimeout(() => this.next(), 200)
            }
        },
        next() {
            const payload = { ...this.tempSignupPayload, agreeVerification: this.selectedIdx }
            localStorage.setItem('tempSignupPayload', JSON.stringify(payload))

            this.$router.push({ name: 'OnboardAgreeMannerFeedback' })
        },
    },
    mounted() {
        this.selectedIdx = this.tempSignupPayload.agreeVerification
        if (this.tempSignupPayload.agreeVerification === undefined) {
            this.$nativeBridge.postMessage({
                action: 'sendFirebaseEvent',
                value: {
                    category: `Enter_AgreeVerificationPage`,
                },
            })
        }
        this.$nativeBridge.postMessage({
            action: 'setBackgroundColor',
            value: {
                top: '#FAF0E1',
                bottom: '#FFF9EF',
            },
        })
    },
}
</script>
